import React from "react";
import s from "./ScoreItem.module.scss";
import ScoreGauge from "../ScoreGauge";
import { Score, score_formatted_labels } from "../../utils/types";

export const ScoreItem: React.FC<{ score: Score }> = ({ score }) => {
  const { type, severity } = score;
  return (
    <li className={s.score}>
      <ScoreGauge score={score} defaultProps={{ strokeWidth: "8px" }} />
      <div className={s.scoreLabels}>
        <h4>{score_formatted_labels[type]} risk</h4>
        <p className={s.scoreLabelsValue}>{severity}</p>
      </div>
    </li>
  );
};
